module.exports = __webpack_public_path__ + "static/img/m_center.99e6e6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mine/m_center.png
// module id = TUYK
// module chunks = 9